// Monday Report Page
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import MondayReport from "components/MondayReport";

function MondayReportPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <MondayReport />
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MondayReportPage;